module.exports = __webpack_public_path__ + "img/Flag_of_Georgia.9afed62b.svg";